import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Switch from "react-switch";
import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import Alert from "react-s-alert";
import moment from "moment";

import isEmpty from "../../../../store/validation/is-Empty";
// import ReasonForCancellation from "../reasonForCancellation/ReasonForCancellation";
//import ReusableSuccessMessage from "../successMesagePopup/ReusableSuccessMessage";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  vendor_update_offer,
  vendor_update_events,
} from "../../../../store/actions/vendorOffersAndEventsAction";

export class ActiveDeactiveEventsAndOffers extends Component {
  constructor(props) {
    super();
    this.state = {
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };

  onActiveToggleChange = (data) => (e) => {
    console.log(data);
  };

  activeOfferEventClick = (offerEventId, actionButton) => (e) => {
    var currentDate = moment().format("YYYY-MM-DD");
    var endDate = moment(offerEventId.end_date).format("YYYY-MM-DD");
    const token = !isEmpty(this.props.auth.user.accessToken)
      ? this.props.auth.user.accessToken
      : "";
    const offerId = offerEventId._id;
    const formData = {
      active: offerEventId.active === true ? false : true,
    };
    if (currentDate > endDate) {
      Alert.error(
        `<h4>You can not ${offerEventId.active === true ? "deactivate" : "activate"
        } this ${actionButton === "offers" ? "offer" : "event"} because ${actionButton === "offers" ? "offer" : "event"
        } is expired</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
      this.onCloseModal();
    } else if (offerEventId?.maximum_usage_limit <= offerEventId?.offerUsed) {
      Alert.error(
        `<h4>Maximum Usage Limit Exceeded</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
      this.onCloseModal();
    } else if (currentDate <= endDate) {
      if (actionButton === "offers") {
        this.props.vendor_update_offer(
          formData,
          offerId,
          token,
          this.onOfferSuccess
        );
      } else {
        this.props.vendor_update_events(
          formData,
          offerId,
          token,
          this.onEventSuccess
        );
      }
    }
  };

  primaryOfferEventClick = (offerEventId, actionButton) => (e) => {
    var currentDate = moment().format("YYYY-MM-DD");
    var endDate = moment(offerEventId.end_date).format("YYYY-MM-DD");
    const token = !isEmpty(this.props.auth.user.accessToken)
      ? this.props.auth.user.accessToken
      : "";
    const offerId = offerEventId._id;
    const formData = {
      vendor_id: this.props.auth.user.VendorUser._id,
      mark_as_primary: offerEventId.mark_as_primary === true ? false : true,
      active: offerEventId?.active,
    };
    if (currentDate > endDate) {
      Alert.error(
        `<h4>You can not primary this ${actionButton === "offers" ? "offer" : "event"
        } because ${actionButton === "offers" ? "offer" : "event"
        } is expired</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
      this.onCloseModal();
    } else if (currentDate <= endDate) {
      if (actionButton === "offers") {
        this.props.vendor_update_offer(
          formData,
          offerId,
          token,
          this.onEventSuccess
        );
      } else {
        this.props.vendor_update_events(
          formData,
          offerId,
          token,
          this.onEventSuccess
        );
      }
    }
  };

  onEventSuccess = (e) => {
    // Alert.success("<h4>Event Update Successfully</h4>", {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
    this.onCloseModal();
  };

  onOfferSuccess = (e) => {
    // Alert.success("<h4>Offer Update Successfully</h4>", {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
    this.onCloseModal();
  };

  render() {
    const { open } = this.state;
    return (
      <React.Fragment>
        <Switch
          checked={
            this.props.displayActive === true
              ? this.props.activeProps.active
              : null || this.props.displayPrimary === true
                ? this.props.activeProps.mark_as_primary
                : null
          }
          onChange={this.onOpenModal}
          // offColor="#EEEEEE"
          onColor="#EEEEEE"
          offHandleColor="#212121"
          onHandleColor="#59F832"
          handleDiameter={this.props.diameter} //19
          uncheckedIcon={false}
          checkedIcon={false}
          offColor="#bcbcbc"
          boxShadow="-2px 0px 5px #0000003B"
          activeBoxShadow="-2px 0px 5px #0000003B"
          height={this.props.height} //22
          width={this.props.width} //45
          id="material-switch"
        />
        <Modal show={open} onHide={this.onCloseModal} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure you want to{" "}
            {this.props.displayActive === true
              ? this.props.activeProps.active === false
                ? "Activate?"
                : "Deactivate"
              : "" || this.props.displayPrimary === true
                ? this.props.activeProps.mark_as_primary === false
                  ? "Set Primary"
                  : "Not Set Primary"
                : ""}
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={this.onCloseModal}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={
                this.props.displayActive === true
                  ? this.activeOfferEventClick(
                    this.props.activeProps,
                    this.props.actionButton
                  )
                  : null || this.props.displayPrimary === true
                    ? this.primaryOfferEventClick(
                      this.props.activeProps,
                      this.props.actionButton
                    )
                    : null
              }
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        {/* <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton:
              this.props.displayButton === true
                ? "customCloseButtonCalling"
                : "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <div className="reusble-popup-header-style">
              <h4 className="f16-500">
                Are you sure you want to{" "}
                {this.props.displayActive === true
                  ? this.props.activeProps.active === false
                    ? "Activate?"
                    : "Deactivate"
                  : "" || this.props.displayPrimary === true
                  ? this.props.activeProps.mark_as_primary === false
                    ? "Set Primary"
                    : "Not Set Primary"
                  : ""}
              </h4>
            </div>

            <div className="bottom-button">
              <PopupActionButton
                buttonText="Yes"
                buttonType="button"
                buttonClass="bigbuttongray"
                onClick={
                  this.props.displayActive === true
                    ? this.activeOfferEventClick(
                        this.props.activeProps,
                        this.props.actionButton
                      )
                    : null || this.props.displayPrimary === true
                    ? this.primaryOfferEventClick(
                        this.props.activeProps,
                        this.props.actionButton
                      )
                    : null
                }
              />
              <PopupActionButton
                buttonText="No"
                buttonType="button"
                buttonClass="bigbuttonred"
                onClick={this.onCloseModal}
              />
            </div>
          </div>
        </Modal> */}
      </React.Fragment>
    );
  }
}

ActiveDeactiveEventsAndOffers.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_update_offer,
  vendor_update_events,
})(withRouter(ActiveDeactiveEventsAndOffers));
